<template>
    <div class="row pt-3 p-md-3">

        <!-- left panel -->
        <div class="d-none d-md-block col-12 col-md-3 col-lg-2">
            <div class="d-flex flex-column">
                <list-item v-for="(menu, index) in leftPanel" :title="menu.title"  :icon="menu.icon" :key="`menu-item-index-${index}`" :url="menu.url" :target="menu.target" />
            </div>
            <hr class="" style="border-color: #dddddd;">
            <div class="text-black bold mb-2">{{ $t('teams') }}</div>
            <div class="position-relative">
                <app-pre-loader v-if="teamsLoading" />
                <template v-else>
                    <list-item v-for="(team, index) in teams" :title="team.name" icon="users" :url="urlGenerator('teams/'+ team.id)" :key="'team-list' + team.id + '-' + index" />
                </template>
            </div>
        </div>

        <div class="col-12 col-md-9 col-lg-10">
            <div class="row">

                <!-- center panel -->
                <div class="col-12 col-lg-9">
                    <div class="d-flex flex-column gap-y-1">
                        <new-post v-if="!readonly"/>
                        <div class="d-flex flex-column gap-y-1">
                            <!-- post list view -->
                            <template>
                                <post-view v-for="(post, index) in posts" :post="post" :recent="post.recent" :key="`post-items-${post.id}`" @edit="edit" @del="del"/>
                            </template>
                            <app-pre-loader v-if="loading" />
                            <app-empty-data-block v-if="!posts.length && !loading" :message="$t('empty_data_block_post')"/>
                        </div>
                    </div>
                </div>

                <!-- right panel -->
                <div class="col-12 d-none d-lg-flex flex-column gap-y-1 col-lg-3 pl-md-0">

                    <!-- profile widget -->
                    <profile-widget />

                    <!-- teammates widget -->
                    <teammate-widget />

                    <!-- notification widget -->
                    <notification-widget />
                </div>

                <!-- post edit modal -->
                <edit-post-modal :id="selectedPostId" modal-id="post-edit-modal" v-if="wannaEdit" @close="closeModal" />
            </div>
        </div>
    </div>
</template>

<script>
// Components
import NewPost from './NewPost'
import PostView from './PostView'
import ListItem from "../others/ListItem";
// Widgets
import ProfileWidget from "../others/widgets/ProfileWidget";
import TeammateWidget from "../others/widgets/TeammateWidget";
import NotificationWidget from "../others/widgets/NotificationWidget";

import {mapGetters} from 'vuex'
import {urlGenerator} from "../../../../helpers/AxiosHelper";
import EditPostModal from "./EditPostModal";
export default {
    components: {NewPost, PostView, EditPostModal, ListItem, ProfileWidget, TeammateWidget, NotificationWidget},
    props: {
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            urlGenerator,
            leftPanel: [
                {id: 1, title: 'news feed', icon: 'rss', url: urlGenerator('/feed'), target: ''},
                {id: 2, title: 'admin', icon: 'settings', url: urlGenerator('/admin/dashboard'), target: '_blank'},
            ],
            wannaEdit: false,
            selectedPostId: null
        }
    },
    computed: {
        ...mapGetters({
            loading: 'posts/loading',
            posts: 'posts/list',
            teams : 'teams/teams',
            teamsLoading: 'teams/loading'
        })
    },
    methods: {
        isActive(url) {
            return window.location.href === url ? 'text-primary' : ''
        },
        del(id) {
            this.$store.dispatch('posts/delPost', id).then(res => {
               this.$toastr.s(res.data.message)
            }).finally(() => {})
        },
        edit(id) {
            this.selectedPostId = id
            this.openModal()
        },
        openModal() {
            this.wannaEdit = true
            $('#post-edit-modal').modal('show');
        },
        closeModal() {
            $('#post-edit-modal').modal('hide');
            this.wannaEdit = false
        },
    },
    mounted() {
        let _this = this
        window.addEventListener('scroll', _.debounce(function (e) {
            let scrollHeight = 944;
            let scrollBarPos = window.scrollY
            let totalHeight = window.document.body.clientHeight - scrollHeight
            if ((scrollBarPos + 20) > totalHeight) {
                if(!_this.loading) {
                    let payloads = { loader: true, teamId: _this.readonly ? window.location.pathname.split('/').pop() : null }
                    _this.$store.dispatch('posts/getAll', payloads)
                    .finally(() =>{})
                }
            }
        }, 500))
    },
    created() {
        this.$store.dispatch('posts/getAll', { loader: true, teamId: this.readonly ? window.location.pathname.split('/').pop() : null })
        this.$store.dispatch('teams/getAll')
    }
}
</script>

<style scoped>
.rounded-lg {
    border-radius: 15px !important;
    /*overflow: hidden;*/
}
</style>